<template>
    <div class="content">
      <h1>ICLone</h1>
      <p>Placeholder.</p>
    </div>

</template>


